import axios from "axios";
const url = "http://localhost:3000";
// const url = "https://mugairyu-id-production.up.railway.app"

export const baseUrl = axios.create({
  baseURL: url,
  headers: {
    access_token: localStorage.access_token,
  },
});
